import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImporterService, JsonbType } from '@xilo-mono/form-contracts';

@Component({
  selector: 'xilo-mono-csv-importer',
  templateUrl: './csv-importer.component.html',
  styleUrls: ['./csv-importer.component.scss'],
})
export class CsvImporterComponent {
  @Output() cancelled: EventEmitter<boolean> = new EventEmitter();
  @Output() completed: EventEmitter<any> = new EventEmitter();
  @Input() licenseKey: string;
  @Input() user: {
    id: string;
    email: string;
    name: string;
    companyId: string;
    companyName: string;
  };
  @Input() importerName: string;

  settings = {
    importIdentifier: 'Clients',
    developmentMode: false,
  };
  dromo;

  constructor(private importerService: ImporterService) {}

  openDromo(dromoFields: any[], fields: any[], data?:JsonbType) {
    if (this.importerName) {
      this.settings.importIdentifier = this.importerName;
    }
    this.dromo =
      typeof (window as any)['DromoUploader'] != 'undefined'
        ? new (window as any)['DromoUploader'](
            this.licenseKey,
            dromoFields,
            this.settings,
            this.user
          )
        : null;
    this.dromo.onResults((response) => {
      const newFields = [];
      for (const resp of response) {
        const row = [];
        for (const [key, value] of Object.entries(resp)) {
          const currentField = fields.find((f) => f.fieldKey === key);
          const newField = {
            value,
            ...currentField,
          };
          row.push(newField);
        }
        newFields.push(row);
      }
      for (const field of fields) {
        const dromoFieldIndex = newFields.findIndex((f) => {
          return f.some((fl) => fl.fieldKey === field.fieldKey);
        });
        if (dromoFieldIndex <= -1) {
          for (const nField of newFields) {
            nField.push({
              value: null,
              ...field,
            });
          }
        }
      }
      this.completeImport(newFields, data);
      return 'Done!';
    });
    this.dromo.onCancel((res) => {
      console.log(res);
      this.cancelled.emit(true);
    });
    this.dromo.open();
  }

  completeImport(newFields: any[], data?:JsonbType) {
    this.completed.emit({ newFields, data });
  }
}
